__turbopack_context__.v({
  "className": "poppins_eee8f782-module__SgFsha__className",
});
